// src/utils/cloudinary.js
const CLOUDINARY_CLOUD_NAME = 'dh09qcx49';
const CLOUDINARY_UPLOAD_PRESET = 'eviction-checker';

// Simple upload function
export const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    formData.append('folder', 'destination-gallery');

    try {
        const response = await fetch(
            `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
            {
                method: 'POST',
                body: formData,
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error?.message || 'Upload failed');
        }

        const data = await response.json();
        return {
            url: data.secure_url,
            public_id: data.public_id,
            width: data.width,
            height: data.height
        };
    } catch (error) {
        console.error('Error uploading to Cloudinary:', error);
        throw new Error('Image upload failed: ' + error.message);
    }
};

// Upload with transformations
export const uploadWithTransformations = async (file, position) => {
    const positionConfig = {
        'large-left': { width: 800, height: 600, crop: 'fill', gravity: 'auto' },
        'large-right': { width: 800, height: 600, crop: 'fill', gravity: 'auto' },
        'medium-top': { width: 1200, height: 400, crop: 'fill', gravity: 'auto' },
        'medium-bottom': { width: 600, height: 400, crop: 'fill', gravity: 'auto' },
        'small-1': { width: 400, height: 300, crop: 'fill', gravity: 'auto' },
        'small-2': { width: 400, height: 300, crop: 'fill', gravity: 'auto' }
    };

    // 🔍 এই লাইনটি চেক করুন: config যেন undefined না হয়
    const config = positionConfig[position] || { width: 800, height: 600, crop: 'fill', gravity: 'auto' };

    // 🔍 Transformation স্ট্রিং বানানোর পদ্ধতি চেক করুন
    const transformationString = `w_${config.width},h_${config.height},c_${config.crop},g_${config.gravity},q_auto:good`;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'eviction-checker');
    formData.append('folder', 'destination-gallery');
    formData.append('transformation', transformationString); // সরাসরি স্ট্রিং হিসেবে পাঠানো হচ্ছে

    try {
        const response = await fetch(
            `https://api.cloudinary.com/v1_1/dh09qcx49/image/upload`,
            {
                method: 'POST',
                body: formData,
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error?.message || 'Upload failed');
        }

        const data = await response.json();
        return {
            url: data.secure_url,
            public_id: data.public_id
        };
    } catch (error) {
        console.error('Error uploading to Cloudinary:', error);
        throw new Error('Image upload failed: ' + error.message);
    }
};

// Simple function to get optimized URL
export const getOptimizedImageUrl = (url, position) => {
    if (!url) return url;

    if (url.includes('cloudinary.com')) {
        const sizes = {
            'large-left': { width: 800, height: 600, crop: 'fill', gravity: 'auto' },
            'large-right': { width: 800, height: 600, crop: 'fill', gravity: 'auto' },
            'medium-top': { width: 1200, height: 400, crop: 'fill', gravity: 'auto' },
            'medium-bottom': { width: 600, height: 400, crop: 'fill', gravity: 'auto' },
            'small-1': { width: 400, height: 300, crop: 'fill', gravity: 'auto' },
            'small-2': { width: 400, height: 300, crop: 'fill', gravity: 'auto' }
        };

        const config = sizes[position] || { width: 800, height: 600, crop: 'fill', gravity: 'auto' };
        const transformation = Object.entries(config)
            .map(([key, value]) => `${key}_${value}`)
            .join(',');

        const parts = url.split('/upload/');
        if (parts.length === 2) {
            // Check if already has transformations
            if (parts[1].includes('/')) {
                const pathParts = parts[1].split('/');
                pathParts[0] = transformation;
                return `${parts[0]}/upload/${pathParts.join('/')}`;
            } else {
                return `${parts[0]}/upload/${transformation},q_auto:good/${parts[1]}`;
            }
        }
    }

    return url;
};

// Basic image validation
export const validateImageSize = (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            resolve({
                width: img.width,
                height: img.height,
                isValid: true,
                aspectRatio: img.width / img.height
            });
        };
        img.onerror = () => {
            resolve({
                width: 0,
                height: 0,
                isValid: false,
                aspectRatio: 0
            });
        };
        img.src = url;
    });
};

// Simple check if image is from Cloudinary
export const isCloudinaryImage = (url) => {
    return url && url.includes('cloudinary.com');
};